import {  keepPreviousData, useQuery } from '@tanstack/react-query';
import * as assetApi from '../../../../api/assets';
import { IPortalPropertyPhotoAsset, TGetPropertiesPhotosFilters } from '../../../../interfaces/asset';
import { IPortalScoreItem } from '../../../../interfaces/property';
import { useSelector } from 'react-redux';
import { buildProfileCompleteMapForNHIDs } from '../../../../utils/profile_completeness';

type Filters = TGetPropertiesPhotosFilters & { profileCompletenessFilterValue: boolean | null };

const useGetOrgPropertyPhotos = (nhID: number, filters?: Filters) => {
    const queryKey = ['asset', 'photos', 'org', nhID, filters];

    const profileCompletenessState: IPortalScoreItem = useSelector(
        ({ ProfileCompletenessState }: any) => ProfileCompletenessState
    );

    const { profileCompletenessFilterValue, ...params } = filters || {};

    const profileMap = buildProfileCompleteMapForNHIDs(profileCompletenessState);

    return  useQuery({
        placeholderData: keepPreviousData,
        queryFn:() => assetApi.getOrgPropertiesPhotos(nhID, params),
        enabled: !!nhID,
        // this 'select' is acting as a frontend filter here
        select: (data) => data.filter((item: IPortalPropertyPhotoAsset) => {
            if (profileCompletenessFilterValue === null) {
                return true;
            }
            const profileCompleteItem = profileMap.get(item.NHID);
            return profileCompleteItem?.PhotoComplete === profileCompletenessFilterValue;
        }),
        queryKey
    });
};

export { useGetOrgPropertyPhotos };